import React, { useState, useEffect } from 'react'
import { FaSun, FaMoon } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { LogIn, User, LogOut, Info, Phone, X, FileText, IndianRupee } from 'lucide-react'

const Navbar = ({ toggleDarkMode, isDark, openLoginModal, openSignupModal }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Check if the user is logged in
  useEffect(() => {
    const checkLoginStatus = () => {
    const token = localStorage.getItem('token'); // Replace 'authToken' with your session key
    const user = localStorage.getItem('user');
    setIsLoggedIn(!!(token && user));
  };
  // Check immediately
    checkLoginStatus();

    // Add event listener for storage changes
    window.addEventListener('storage', checkLoginStatus);

    // Clean up
    return () => {
      window.removeEventListener('storage', checkLoginStatus);
    };
  },  []);

  // Handle logout
  const handleLogout = () => {
    // Clear all localStorage data
    localStorage.clear();
    
    // Clear sessionStorage data
    sessionStorage.clear();
    
    // Clear IndexedDB (if used)
    if ('indexedDB' in window) {
      indexedDB.databases().then(databases => {
        databases.forEach(db => {
          indexedDB.deleteDatabase(db.name);
        });
      }).catch(() => {});
    }
    
    // Clear service worker cache
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      }).catch(() => {});
    }
    
    // Show logout success toast
    toast.success('You have been logged out successfully!', {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    
    // Wait for toast to show then reload page
    setTimeout(() => {
      window.location.href = '/';
      window.location.reload(true); // Force reload from server
    }, 2000);
  };

  return (
    <nav className="bg-blue-600 text-white sticky top-0 z-50 shadow-md">
      <div className="mx-1 flex justify-between items-center px-4 py-3">
        {/* Left Section */}
        <div className="flex items-center gap-8">
          <Link to="/" className="flex items-center gap-8 md:gap-4">
          <img src="/logo.png" alt="Logo" className="h-11 w-11 object-contain bg-white rounded-full p-1" />
          {/* <h1 className="text-xl font-bold">RTO Bharat</h1> */}
          </Link>
          <ul className="hidden md:flex gap-6 font-medium">
            <li>
              <Link to="/" className="flex items-center gap-2 hover:text-gray-200 transition-colors">
                {/* <Home className="w-4 h-4" /> */}
                <span>RTO Bharat</span>
              </Link>
            </li>
            <li>
              <Link to="/about" className="flex items-center gap-2 hover:text-gray-200 transition-colors">
                <Info className="w-4 h-4" />
                <span>About</span>
              </Link>
            </li>
            <li>
              <Link to="/contact" className="flex items-center gap-2 hover:text-gray-200 transition-colors">
                <Phone className="w-4 h-4" />
                <span>Contact</span>
              </Link>
            </li>
            <li>
              <Link to="/pricing" className="flex items-center gap-2 hover:text-gray-200 transition-colors">
                <IndianRupee className="w-4 h-4" />
                <span>Pricing</span>
              </Link>
            </li>
            {/* {isLoggedIn && ( */}
              <li>
                <Link to="/my-applications" className="flex items-center gap-2 hover:text-gray-200 transition-colors">
                  <FileText className="w-4 h-4" />
                  <span>My Applications</span>
                </Link>
              </li>
            {/* )} */}
          </ul>
        </div>

        {/* Right Section */}
<div className="hidden md:flex items-center gap-6">

  {/* Always show Profile */}
  <Link
    to="/user-dashboard"
    className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20 hover:bg-white hover:text-blue-600 transition"
    title="Profile"
  >
    <User className="w-5 h-5" />
  </Link>

  {/* Keep Login/Logout logic */}
  {isLoggedIn ? (
    <button
      onClick={handleLogout}
      className="flex items-center gap-2 px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded transition"
    >
      <LogOut className="w-4 h-4" />
      Logout
    </button>
  ) : (
    <button
      onClick={openLoginModal}
      className="flex items-center gap-2 px-3 py-1 bg-green-600 hover:bg-green-700 text-white rounded transition"
    >
      <LogIn className="w-4 h-4" />
      Login
    </button>
  )}

  <button
    onClick={toggleDarkMode}
    className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20 hover:bg-white hover:text-blue-600 transition"
  >
    {isDark ? <FaSun /> : <FaMoon />}
  </button>

</div>

        {/* Mobile Hamburger */}
        <div className="flex md:hidden flex-col justify-center items-center w-8 h-8 cursor-pointer" onClick={() => setMenuOpen(!menuOpen)}>
          <div className="relative">
            <span className={`block w-6 h-0.5 bg-white transition-all duration-300 transform ${menuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></span>
            <span className={`block w-6 h-0.5 bg-white mt-1 transition-all duration-300 ${menuOpen ? 'opacity-0 scale-0' : ''}`}></span>
            <span className={`block w-6 h-0.5 bg-white mt-1 transition-all duration-300 transform ${menuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></span>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
{menuOpen && (
  <div className="fixed inset-0 z-50 md:hidden">
    {/* Backdrop */}
    <div
      className={`fixed inset-0 bg-black transition-all duration-500 ease-out backdrop-blur-sm ${
        menuOpen ? "bg-opacity-60" : "bg-opacity-0"
      }`}
      onClick={() => setMenuOpen(false)}
    />

    {/* Slide-out Menu */}
    <div
      className={`fixed top-0 left-0 h-screen w-80 bg-gradient-to-b from-blue-700 to-blue-800 shadow-2xl transform transition-all duration-500 ease-out ${
        menuOpen
          ? "translate-x-0 opacity-100 scale-100"
          : "-translate-x-full opacity-0 scale-95"
      }`}
    >
      {/* Menu Header */}
      <Link to="/" onClick={() => setMenuOpen(false)}>
        <div className="flex items-center justify-between p-4 border-b border-blue-600">
          <img
            src="/logo.png"
            alt="Logo"
            className="h-14 w-14 object-contain bg-white rounded-full p-1"
          />
          <h2 className="text-xl font-bold text-white">RTO Bharat</h2>
          <button
            onClick={() => setMenuOpen(false)}
            className="p-2 rounded-full hover:bg-blue-600 transition-all duration-200 transform hover:rotate-90"
          >
            <X className="w-5 h-5 text-white" />
          </button>
        </div>
      </Link>

      {/* Menu Content */}
      <div className="flex flex-col justify-between h-[calc(100%-80px)]">
        {/* Navigation Links */}
        <div className="flex-1 py-4 overflow-hidden">
          <div className="space-y-2 px-4">

            <Link
              to="/about"
              className={`flex items-center gap-3 p-3 rounded-lg hover:bg-blue-600 hover:shadow-lg text-white transition-all duration-300 transform hover:translate-x-2 hover:scale-105 ${
                menuOpen ? "animate-slideInLeft" : ""
              }`}
              style={{ animationDelay: "200ms" }}
              onClick={() => setMenuOpen(false)}
            >
              <Info className="w-5 h-5" />
              <span className="font-medium">About</span>
            </Link>

            <Link
              to="/contact"
              className={`flex items-center gap-3 p-3 rounded-lg hover:bg-blue-600 hover:shadow-lg text-white transition-all duration-300 transform hover:translate-x-2 hover:scale-105 ${
                menuOpen ? "animate-slideInLeft" : ""
              }`}
              style={{ animationDelay: "300ms" }}
              onClick={() => setMenuOpen(false)}
            >
              <Phone className="w-5 h-5" />
              <span className="font-medium">Contact</span>
            </Link>

            <Link
              to="/pricing"
              className={`flex items-center gap-3 p-3 rounded-lg hover:bg-blue-600 hover:shadow-lg text-white transition-all duration-300 transform hover:translate-x-2 hover:scale-105 ${
                menuOpen ? "animate-slideInLeft" : ""
              }`}
              style={{ animationDelay: "325ms" }}
              onClick={() => setMenuOpen(false)}
            >
              <IndianRupee className="w-5 h-5" />
              <span className="font-medium">Pricing</span>
            </Link>

            {/* Always Visible */}
            <Link
              to="/my-applications"
              className={`flex items-center gap-3 p-3 rounded-lg hover:bg-blue-600 hover:shadow-lg text-white transition-all duration-300 transform hover:translate-x-2 hover:scale-105 ${
                menuOpen ? "animate-slideInLeft" : ""
              }`}
              style={{ animationDelay: "350ms" }}
              onClick={() => setMenuOpen(false)}
            >
              <FileText className="w-5 h-5" />
              <span className="font-medium">My Applications</span>
            </Link>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="flex-shrink-0 border-t border-blue-600">

          {/* User Actions */}
          <div className="p-4">
            <div className="space-y-3">

              {/* Always Visible */}
              <Link
                to="/user-dashboard"
                className={`flex items-center gap-3 w-full p-3 bg-blue-600 hover:bg-blue-500 hover:shadow-lg text-white rounded-lg transition-all duration-300 transform hover:scale-105 hover:translate-x-1 ${
                  menuOpen ? "animate-slideInRight" : ""
                }`}
                style={{ animationDelay: "400ms" }}
                onClick={() => setMenuOpen(false)}
              >
                <User className="w-5 h-5" />
                <span className="font-medium">Profile</span>
              </Link>

              {/* Login / Logout */}
              {isLoggedIn ? (
                <button
                  onClick={() => {
                    handleLogout();
                    setMenuOpen(false);
                  }}
                  className={`flex items-center gap-3 w-full p-3 bg-red-500 hover:bg-red-600 hover:shadow-lg text-white rounded-lg transition-all duration-300 transform hover:scale-105 hover:translate-x-1 ${
                    menuOpen ? "animate-slideInRight" : ""
                  }`}
                  style={{ animationDelay: "500ms" }}
                >
                  <LogOut className="w-5 h-5" />
                  <span className="font-medium">Logout</span>
                </button>
              ) : (
                <button
                  onClick={() => {
                    openLoginModal();
                    setMenuOpen(false);
                  }}
                  className={`flex items-center gap-3 w-full p-3 bg-green-600 hover:bg-green-700 hover:shadow-lg text-white rounded-lg transition-all duration-300 transform hover:scale-105 hover:translate-x-1 ${
                    menuOpen ? "animate-slideInRight" : ""
                  }`}
                  style={{ animationDelay: "500ms" }}
                >
                  <LogIn className="w-5 h-5" />
                  <span className="font-medium">Login</span>
                </button>
              )}
            </div>
          </div>

          {/* Theme Toggle */}
          <div className="border-t border-blue-600 p-4">
            <button
              onClick={toggleDarkMode}
              className={`flex items-center gap-3 w-full p-3 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 hover:shadow-xl text-white rounded-lg transition-all duration-500 transform hover:scale-110 hover:translate-x-1 ${
                menuOpen ? "animate-slideInUp" : ""
              }`}
              style={{ animationDelay: "600ms" }}
            >
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-white bg-opacity-20 transition-all duration-300 transform hover:rotate-12">
                {isDark ? (
                  <FaSun className="w-5 h-5 text-yellow-300 transition-all duration-300 transform hover:rotate-180" />
                ) : (
                  <FaMoon className="w-5 h-5 text-blue-300 transition-all duration-300 transform hover:rotate-12" />
                )}
              </div>
              <span className="font-medium">
                {isDark ? "Light Mode" : "Dark Mode"}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
)}
    </nav>
  )
}

export default Navbar
